import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { UpdateLimiteProduit } from "../../core/model/limiteproduit/update-limite-produit";
import { LimiteProduitDTO } from "../../core/model/limiteproduit/limite-produit-dto";
import { LimiteProduitService } from "../../core/service/limite-produit.service";

@Component({
  selector: "app-edit-limite-produit",
  templateUrl: "./edit-limite-produit.component.html",
  styleUrls: ["./edit-limite-produit.component.scss"],
})
export class EditLimiteProduitComponent implements OnInit {
  erreur: String = "";

  @Input()
  set limiteProduit(value: LimiteProduitDTO) {
    if (value) {
      this._limiteProduit = { ...value };
      this.updateLimiteProduit = {
        limiteProduitId: value.id,
        limiteAutorise: value.limiteAutorise,
      };
      this.cdr.detectChanges();
    }
  }
  get limiteProduit(): LimiteProduitDTO {
    return this._limiteProduit;
  }

  private _limiteProduit: LimiteProduitDTO;
  updateLimiteProduit: UpdateLimiteProduit = new UpdateLimiteProduit();

  form2: FormGroup;
  pressButton: Boolean = false;
  loading = false;

  constructor(
    private _limiteProduitService: LimiteProduitService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      limiteAutorise: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this._limiteProduitService
      .update(this.updateLimiteProduit)
      .pipe(first())
      .subscribe(
        () => {
          const updated: LimiteProduitDTO = {
            ...this.limiteProduit,
            id: this.updateLimiteProduit.limiteProduitId,
            limiteAutorise: this.updateLimiteProduit.limiteAutorise,
          };
          this.pressButton = false;
          this.activeModal.close(updated);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
